import React from "react";

import BadgeJobStatus from "Components/Generic/BadgeJobStatus";
import { Job } from "Models/job";

import useStyles, {
  Arrow,
  CustomerName,
  OrderOption,
  OrderOptionHeader,
  OrderReference,
  TaskAddress,
  TaskAddressContainer,
} from "./styles";

type Props = {
  data: Job;
};

export const CreateTaskOrderOption: React.FC<Props> = ({ data: job }) => {
  const classes = useStyles();

  return (
    <OrderOption>
      <OrderOptionHeader>
        <OrderReference>#{job?.reference}</OrderReference>
        <BadgeJobStatus value={job?.status} className={classes.statusChip} />
      </OrderOptionHeader>
      <div>
        <CustomerName>{job?.customer?.fullName || ""}</CustomerName>
        <TaskAddressContainer>
          <TaskAddress>{`${
            job?.origins?.[0]?.state && job?.origins?.[0]?.state !== undefined
              ? `${job?.origins?.[0]?.state}, `
              : `${job?.origins?.[0]?.longAddress}, `
          }${job?.origins?.[0]?.country}`}</TaskAddress>
          <Arrow>→</Arrow>
          <TaskAddress>{`${
            job?.destinations?.[0]?.state && job?.destinations?.[0]?.state !== undefined
              ? `${job?.destinations?.[0]?.state}, `
              : `${job?.destinations?.[0]?.longAddress}, `
          }${job?.destinations?.[0]?.country}`}</TaskAddress>
        </TaskAddressContainer>
      </div>
    </OrderOption>
  );
};
